module.exports = __webpack_public_path__ + "9c0283022db10fbc976580fc05082502.jpg";